// extracted by mini-css-extract-plugin
export default {"extra":"_7JItU","skeleton-progress":"mAJOS"};